import { render, staticRenderFns } from "./KnowledgeBaseDetail.vue?vue&type=template&id=f6570a82&scoped=true"
import script from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseDetail.vue?vue&type=style&index=0&id=f6570a82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6570a82",
  null
  
)

export default component.exports